<template>
  <CrudDataTable :con="con" :items="centers" ref="dataTable" sortBy="name">
    <template v-slot:owner-name>{{ "Dawan" }}</template>
    <template v-slot:item.imageBase64="{ item }">
      <div class="center-photo-icon">
        <base-64-to-image
          v-if="item.imageBase64"
          :base64Image="item.imageBase64"
          :alt="item.name"
        />
      </div>
    </template>
    <template v-slot:item.partialCap="{ item }">
      <v-chip>
        {{ item.partialCap ? "oui" : "non" }}
      </v-chip>
    </template>

    <template v-slot:[`moreActions`]="{ item }">
      <v-tooltip bottom>
        <template #activator="{ on }">
          <v-icon small @click="goToDetails(item)" v-on="on">
            mdi-information
          </v-icon>
        </template>
        <span>{{ $t("crudCommon.tooltipDetails") }}</span>
      </v-tooltip>

      <v-tooltip bottom>
        <template #activator="{ on }">
          <v-icon small @click="openRooms(item)" v-on="on">
            mdi-widgets
          </v-icon>
        </template>
        <span>{{ $t("crudCenter.tooltipRooms") }}</span>
      </v-tooltip>

      <v-tooltip bottom>
        <template #activator="{ on }">
          <v-icon @click="openEquipments(item)" v-on="on"> mdi-monitor </v-icon>
        </template>
        <span>{{ $t("crudCenter.tooltipEquipments") }}</span>
      </v-tooltip>
    </template>

    <template v-slot:dialog-form="{ item }">
      <EditCenterForm :con="con" :editedItem="item" @closed="closeEditDialog" />
    </template>
  </CrudDataTable>
</template>

<script>
import CrudDataTable from "../CrudDataTable";
import EditCenterForm from "./EditCenterForm";
import CrudCentersTable from "@/models/crud/CrudCentersTable";
import base64ToImage from "@/components/components-base/image/base64ToImage";
import { mapActions } from "vuex";

export default {
  name: "CrudCenters",
  components: {
    CrudDataTable,
    EditCenterForm,
    base64ToImage,
  },
  props: {
    centers: null,
  },
  computed: {
    con() {
      return {
        ...CrudCentersTable,
        crud: {
          indexOf: (item) => {
            return this.centers.indexOf(item);
          },
          create: (item) => {
            return this.addCenter(item);
          },
          update: (item) => {
            return this.editCenter(item);
          },
          delete: (item) => {
            return this.deleteCenter(item);
          },
        },
      };
    },
  },
  methods: {
    ...mapActions("centerModule", ["addCenter", "editCenter", "deleteCenter"]),

    closeEditDialog() {
      this.$refs.dataTable.closeEdit();
    },
    goToDetails(item) {
      this.$router.push({
        name: "admin-center-details",
        params: { centerId: item.id },
      });
    },
    openRooms(item) {
      this.$router.push({
        name: "admin-center-rooms",
        params: { centerId: item.id },
      });
    },
    openEquipments(item) {
      this.$router.push({
        name: "admin-center-equipments",
        params: { centerId: item.id },
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.center-photo-icon {
  img {
    width: 50px;
    height: 50px;
  }
}
</style>
